// extracted by mini-css-extract-plugin
export default {"tasksTableContainer":"Task_tasksTableContainer__dq2iQ"};